import React from "react";
import { Link } from "react-router-dom";

const LOGOS = {
  full: "/logos/krionex-logo-full.png",
  wordmark: "/logos/krionex-logo-wordmark.png",
  icon: "/logos/krionex-icon.png",
};

export default function KrionexLogo({
  variant = "wordmark",
  to = "/",
  className = "",
  imageClassName = "",
  framed = false,
}) {
  const src = LOGOS[variant] || LOGOS.wordmark;

  const image = (
    <img
      src={src}
      alt="Krionex"
      className={
        imageClassName ||
        (variant === "icon"
          ? "h-12 w-12 object-contain"
          : "h-12 w-auto object-contain")
      }
    />
  );

  const content = framed ? (
    <div
      className={`inline-flex items-center justify-center rounded-2xl border border-slate-800 bg-black px-3 py-2 shadow-[0_16px_45px_rgba(15,23,42,0.22)] ${className}`}
    >
      {image}
    </div>
  ) : (
    <div className={`inline-flex items-center ${className}`}>{image}</div>
  );

  if (!to) return content;

  return (
    <Link to={to} className="inline-flex items-center">
      {content}
    </Link>
  );
}